export const isDateMinValue = dateObj =>
  dateObj < new Date('1900-01-01T00:00:01')
